import { ACTION_TYPES } from 'constants'

export const setMenuDrawer = (payload) => ({
  type: ACTION_TYPES.MENU_TOGGLE,
  payload,
})
